'use client';

import { useState } from 'react';

type CommentsSnapshot = {
  comments: ReadonlyArray<{ id: number }>;
  knownIds: Set<number> | null;
};

export function useEnteringCommentIds(comments: ReadonlyArray<{ id: number }>): Set<number> {
  const [snapshot, setSnapshot] = useState<CommentsSnapshot>({
    comments,
    knownIds: null,
  });

  if (snapshot.comments !== comments) {
    setSnapshot({
      comments,
      knownIds: new Set(snapshot.comments.map((comment) => comment.id)),
    });
  }

  const knownIds =
    snapshot.comments === comments
      ? snapshot.knownIds
      : new Set(snapshot.comments.map((comment) => comment.id));

  const enteringCommentIds = new Set<number>();
  if (!knownIds) {
    return enteringCommentIds;
  }

  for (const comment of comments) {
    if (!knownIds.has(comment.id)) {
      enteringCommentIds.add(comment.id);
    }
  }

  return enteringCommentIds;
}
